import request from '../servises/blogRequest'

export function getCategories(params) {
    if(params) {
        params = `?${params}`
    } else {
        params = ''
    }

    return request({
        url: `categories/${params}`,
        method: 'GET'
    })
}

export function deleteCategory(params) {
    return request({
        url: `categories/${params}`,
        method: 'DELETE'
    })
}

export function getShowCategory(params) {
    return request({
        url: `categories/${params}`,
        method: 'GET'
    })
}

export function updateCategory(params) {
    return request({
        url: `categories/${params.id}`,
        method: 'PUT',
        data: params
    })
}

export function createCategory(params) {
    return request({
        url: `categories`,
        method: 'POST',
        data: params
    })
}